import useDeviceWidth from './useDeviceWidth';

export const useIsMobile = () => {
	const width = useDeviceWidth();
	const isMobile = width < 768;

	return {
		isMobile,
	};
};
